module.exports = __webpack_public_path__ + "static/media/rd-gcbanner-base.5cc726a2.png";